import { api } from "@/lib/api";

export const REPORT_FORMATS = [
  {
    key: "pdf",
    label: "PDF",
    extension: "pdf",
    mime: "application/pdf",
    description: "Rapport complet (jsPDF + html2canvas)",
    icon: "FileText",
  },
  {
    key: "docx",
    label: "Word",
    extension: "docx",
    mime:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    description: "Document .docx éditable",
    icon: "FileType",
  },
  {
    key: "xlsx",
    label: "Excel",
    extension: "xlsx",
    mime:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    description: "Onglets multiples + formules visibles",
    icon: "Table",
  },
  {
    key: "png",
    label: "Infographie",
    extension: "png",
    mime: "image/png",
    description: "Poster A3 paysage 300 DPI",
    icon: "Image",
  },
];

export function buildReportFilename({
  country = "Inconnu",
  fiscalYear = "",
  extension,
}) {
  const d = new Date();
  const date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
  const safeCountry = (country || "Inconnu")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  const parts = ["VITAE-PUBLICA", safeCountry];
  if (fiscalYear) parts.push(String(fiscalYear));
  parts.push(date);
  return `${parts.join("_")}.${extension}`;
}

export async function listReports(projectId) {
  const { data } = await api.get(`/projects/${projectId}/reports`);
  return data.data;
}

export async function logReport(projectId, payload) {
  const { data } = await api.post(`/projects/${projectId}/reports`, payload);
  return data.data;
}

export async function deleteReport(reportId) {
  const { data } = await api.delete(`/reports/${reportId}`);
  return data;
}
